export const CONTENT_TRANSFER_ENCODING_OPTIONS = Object.freeze([
  Object.freeze({ value: '7bit', label: '7bit' }),
  Object.freeze({ value: '8bit', label: '8bit' }),
  Object.freeze({ value: 'binary', label: 'Binary' }),
  Object.freeze({ value: 'base64', label: 'Base64' }),
  Object.freeze({ value: 'quoted-printable', label: 'Quoted-Printable' })
]);